import { Extension } from "@tiptap/core";
import { Plugin } from "prosemirror-state";
import { Decoration, DecorationSet } from "prosemirror-view";

const TABLE_TYPES = ["table", "variableTable"];

export const TableSelectionExtension = Extension.create({
    name: "tableSelection",

    addProseMirrorPlugins() {
        return [
            new Plugin({
                props: {
                    decorations(state) {
                        const { from, to, empty } = state.selection;

                        if (empty) {
                            return DecorationSet.empty;
                        }

                        const decorations = [];

                        state.doc.descendants((node, pos) => {
                            if (!TABLE_TYPES.includes(node.type.name)) {
                                return;
                            }

                            const tableFrom = pos;
                            const tableTo = pos + node.nodeSize;

                            const isSelected =
                                from < tableTo &&
                                to > tableFrom;

                            if (isSelected) {
                                decorations.push(
                                    Decoration.node(tableFrom, tableTo, {
                                        class: "table-selected"
                                    })
                                );
                            }
                        });

                        return DecorationSet.create(
                            state.doc,
                            decorations
                        );
                    },

                    handleKeyDown(view, event) {
                        if (
                            event.key !== "Backspace" &&
                            event.key !== "Delete"
                        ) {
                            return false;
                        }

                        const { state } = view;
                        const { from, to, empty } = state.selection;

                        if (empty) {
                            return false;
                        }

                        let hasTable = false;

                        state.doc.nodesBetween(from, to, (node) => {
                            if (TABLE_TYPES.includes(node.type.name)) {
                                hasTable = true;
                            }
                        });

                        if (!hasTable) {
                            return false;
                        }

                        view.dispatch(
                            state.tr.deleteSelection().scrollIntoView()
                        );

                        return true;
                    }
                }
            })
        ];
    }
});